import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Phone } from 'lucide-react';

export function CtaSection() {
  return (
    <section className="py-24 gradient-mesh relative" data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <img src="/mlctech-logo.png" alt="" className="h-16 w-auto mx-auto mb-8 opacity-60" aria-hidden="true" />
        <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-6" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Ready to Upgrade Your IT?
        </h2>
        <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto">
          Get a free IT assessment and discover how MLC TECH can help your business
          run smoother, safer, and more efficiently.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact">
            <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white font-semibold shadow-lg shadow-blue-500/20 btn-hover-lift" data-testid="cta-get-quote-btn">
              Get Your Free IT Quote Today
            </Button>
          </Link>
          <a href="tel:6026491314">
            <Button size="lg" variant="outline" className="border-slate-300" data-testid="cta-call-btn">
              <Phone className="w-4 h-4 mr-2" /> Call (602) 649-1314
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
